import React from 'react';
import {CloseIcon} from '../Icons/Icons';
import classnames from 'classnames';

import "./sidepopup.scss";
import TextTranslate from '../TextTranslate/TextTranslate';

function SidePopup({ isOpen, children, ...props }) {
    return (
        <div
            className={classnames(
                ["sidepopup-wrapper",
                    {
                        open: isOpen
                    }
                ])}
        >
            <div className="content">
                <div className="popup-close">
                    <CloseIcon onClick={props.toggleMyProfile}/>
                </div>
                <div>
                    <h2><TextTranslate name="user-my-profile" fallback="My Profile" textOnly/></h2>
                </div>
                <div className="d-flex flex-column h-100">
					<h4><TextTranslate name="user-account-details" fallback="Account Details" textOnly/></h4>
					{children}
                </div>
            </div>

            <div className="dimmer" onClick={props.toggleMyProfile}></div>
        </div>
    )
}

export default SidePopup;